export const log = (msg) => {
  if ("production" !== process.env.NODE_ENV) console.log(msg);
}

export default () => {

}